<template lang="pug">
  .user-orders
    .user-orders__title
      h1.title Заявки
    .user-orders__main
      .orders
        .orders__header
          .tabs
            .tabs__item(
            v-for="(tab, index) in tabs"
            )
              .button(
                @click="currentTab = index"
              :class="{ 'button_paint-main': currentTab === index }"
              ) {{tab.text}}
        .orders__main
          .orders__list.orders-list
            .orders-list__item(
              v-for="order in ordersData"
            )
              order-obj(
                :order="order"
                @onChangeOrderStatus="onChangeOrderStatus"
                @delete="showUserOrderModal"
              )
            div(v-if="ordersData.length === 0") Заявок нет
    .user-orders__pagination(
      v-if="paginationAmountToShow < ordersAmount"
    )
      custom-pagination(
      :elements-amount="ordersAmount"
      :amount-to-show="paginationAmountToShow"
      :current-page="paginationCurrentPage"
      @on-button-click="onPaginationButtonClick"
      )

    modal(
    v-if="showModal && currentOrder"
      :mode="modalMode"
        :modalData="currentOrder"
        @close="showModal = false"
        @changeModalMode="changeModalMode"
    )
</template>

<script>
import { mapActions } from "vuex";
import OrderObj from "./components/order-obj";
import Modal from "../../../../components/modal/modal.vue";
import CustomPagination from "../../../../components/pagination/pagination";

export default {
  name: "user-orders",
  components: {
    CustomPagination,
    Modal,
    OrderObj,
  },
  data() {
    return {
      showModal: false,
      modalMode: "user-order",
      modalData: null,
      currentOrder: null,
      currentTab: 0,
      statusesByType: {
        0: "1,2,3,4",
        1: "5,6,7",
      },
      tabs: [
        {
          text: "Активные заявки",
        },
        {
          text: "Архив заявок",
        },
      ],
      ordersData: [],
      /*для пагинации*/
      ordersAmount: null,
      paginationAmountToShow: 10,
    };
  },
  computed: {
    paginationCurrentPage() {
      return Number(this.$route.query.page) || 1;
    },
  },
  methods: {
    ...mapActions(["getOrders", "changeOrderStatus"]),
    onGetOrders(pageNumber) {
      let params = {
        current_status__in: this.statusesByType[this.currentTab],
        page_size: this.paginationAmountToShow,
        page: pageNumber,
      };
      this.getOrders(params).then((res) => {
        this.ordersData = res.results;
        this.ordersAmount = res.count;
      });
    },
    onChangeOrderStatus(id) {
      // preloader.show
      this.changeOrderStatus(id)
        .then(() => {
          this.onGetOrders();
          this.showModal = false;
        })
        .catch(function (e) {
          throw e;
        });
    },
    showUserOrderModal(id) {
      this.showModal = true;
      this.modalMode = "user-order";
      this.currentOrder = {
        order: id,
      };
    },
    changeModalMode(data) {
      this.onChangeOrderStatus(data.order);
    },
    onPaginationButtonClick(button) {
      this.$router.replace({ query: { page: button } });
      this.onGetOrders(button);
    },
  },
  mounted() {
    this.onGetOrders(this.paginationCurrentPage);
  },
  watch: {
    currentTab() {
      this.onGetOrders();
    },
  },
};
</script>
